import(/* webpackMode: "eager" */ "/app/apps/ashbond/app/[locale]/not-found.tsx");
